import lodash from 'lodash'
import { produce } from 'immer'
import { cloneDeep } from 'lodash'
import { message } from 'antd'
import * as services from '@/pages/person/shortcut/service'
import { formatGroupList } from './util'
import { queryResource } from '@/pages/case/story/service'

const UserModel = {
  namespace: 'shortcutList',

  state: {
    groupList: [],
    list: [],
    loading: false,
    refresh: false,
    groupId: '',
    searchValue: {
      fuzzy: null,
      page_num: 1,
      page_size: 20,
    },
    totalNum: 0,
  },

  subscriptions: {
    // setup: ({ dispatch, history }) => {
    //   return history.listen(({ pathname }) => {
    //     if (pathname === '/person/shortcut') {
    //       dispatch({
    //         type: 'fetchGroupList',
    //         payload: {},
    //       })
    //       dispatch({
    //         type: 'phraseAllList',
    //         payload: {},
    //       })
    //     }
    //   })
    // },
  },
  effects: {
    // 获取分组
    *fetchGroupList({ payload }, { call, put }) {
      const res = yield call(services.fetchGroupList, payload)
      const filterList = res?.data?.group_list?.filter((i) => i.parent_id)
      const groupList =
        res?.data?.group_list
          ?.filter((item) => !item.parent_id)
          .map((item) => ({
            name: item.name,
            value: item.id,
            parent_id: item.parent_id,
            role: item.role,
            children: formatGroupList(filterList, item?.id),
          })) || []
      if (groupList?.some((i) => i?.name === '未分组')) {
        groupList.forEach((item, index) => {
          if (item.name === '未分组') {
            groupList.unshift(groupList.splice(index, 1)[0])
          }
        })
      } else {
        groupList.unshift({
          name: '未分组',
          value: '未分组',
          parent_id: '',
          role: groupList?.[0]?.role,
          children: [],
        })
      }
      yield put({
        type: 'setState',
        payload: { groupList },
      })
      return res
    },

    *phraseList({ payload }, { put, call, select }) {
      const { role, user_id, group_id } = payload
      const list = yield select((state) => state.shortcutList.groupList)
      const defaultId = list?.filter((i) => i?.name === '未分组')?.[0]?.value || list?.[0]?.value

      yield put({
        type: 'setState',
        payload: { loading: true },
      })
      const res = yield call(services.phraseList, { ...payload, group_id: group_id || defaultId })
      yield put({
        type: 'setState',
        payload: {
          list: res?.data?.data,
          loading: false,
          refresh: false,
          totalNum: res?.data?.page?.total,
        },
      })
      return res
    },

    *shortListByPage({ payload }, { put, call, select }) {
      const { searchKey, group_id } = payload
      const list = yield select((state) => state.shortcutList.groupList)
      const searchValue = yield select((state) => state.shortcutList.searchValue)
      const defaultId = list?.filter((i) => i?.name === '未分组')?.[0]?.value || list?.[0]?.value

      let listSearchVal
      if (searchKey) {
        listSearchVal = searchKey
      } else {
        listSearchVal = searchValue
      }

      yield put({
        type: 'setState',
        payload: { loading: true },
      })
      const res = yield call(services.shortListByPage, {
        ...payload,
        group_id: group_id || defaultId,
        page_num: listSearchVal.page_num,
        page_size: listSearchVal.page_size,
        fuzzy: listSearchVal.fuzzy,
      })

      yield put({
        type: 'setState',
        payload: {
          list: res?.data?.data,
          loading: false,
          refresh: false,
          totalNum: res?.data?.page?.total,
        },
      })
      return res
    },

    *deletePhrase({ payload }, { put, call, select }) {
      const res = yield call(services.deletePhrase, payload)
      return res
    },

    *resetGroupSearch({ payload }, { put, call }) {
      yield put({
        type: 'fetchGroupList',
        payload: {
          role: payload.role,
        },
      })
      yield put({
        type: 'shortListByPage',
        payload: { role: payload.role, group_id: payload.group_id },
      })
    },

    *addAndEditGroup({ payload }, { put, call }) {
      if (payload?.name === '未分组') {
        return message.error('分组名称已存在')
      }
      const res = yield call(services.addAndEditGroup, payload)
      return res
    },

    *BatchGrouping({ payload }, { put, call }) {
      const res = yield call(services.BatchGrouping, payload)
      return res
    },

    *deleteGroup({ payload }, { put, call, select }) {
      const res = yield call(services.deleteGroup, payload)
      return res
    },

    *clearPhrase({ payload }, { put, call }) {
      const res = yield call(services.clearPhrase)
      yield put({
        type: 'setState',
        payload: {
          groupList: [],
          list: [],
          groupId: '未分组',
        },
      })
      return res
    },

    *ImportPhraseDownloadCenter({ payload }, { put, call, select }) {
      const res = yield call(services.ImportPhraseDownloadCenter, payload)
      return res
    },
    *queryResource({ payload }, { call, put }) {
      const result = yield call(queryResource, payload)
      return result
    },
  },
  reducers: {
    setState(state = {}, { payload }) {
      return {
        ...state,
        ...payload,
      }
    },
    cleared: produce((state) => {
      state.groupList = []
      state.searchValue = {
        fuzzy: null,
        page_num: 1,
        page_size: 20,
      }
      state.list = []
      state.loading = false
      state.refresh = false
      state.groupId = ''
    }),
    resetSearchVal: produce((state) => {
      state.searchValue = {
        page_num: 1,
        page_size: 20,
        fuzzy: null,
      }
    }),
  },
}

export default UserModel
